import React, { useEffect, useRef, useState } from 'react';
import { Toggle } from '../../Objects/Toggle/Toggle';
import uuidv4 from '../../utils/uuidv4';
import classNames from 'classnames';
/**
 * Bronson FoldOut component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-fold-out.html
 * @constructor
 */
export function FoldOut({ children, defaultOpen = false, isOpen: isControlledOpen, fullToggle, labelHidden, labelUnhidden, productInfoSummary, showFooterTrigger, testId, onToggle, ...otherProps }) {
    const [buttonId] = useState(uuidv4());
    const [targetId] = useState(uuidv4());
    const isControlled = isControlledOpen !== undefined;
    const [isOpen, setIsOpen] = useState(isControlledOpen || defaultOpen);
    useEffect(() => {
        if (isControlled) {
            setIsOpen(isControlledOpen);
        }
    }, [isControlledOpen]);
    const handleToggle = () => {
        const newState = !isOpen;
        if (!isControlled)
            setIsOpen(newState);
        onToggle?.(newState);
    };
    const ref = useRef(null);
    const divClassNameList = classNames('c-fold-out', { 'c-fold-out--full-toggle': fullToggle }).trim();
    function renderHeader() {
        return React.createElement("div", { className: "c-fold-out__header" }, productInfoSummary);
    }
    function renderContent() {
        return (React.createElement("div", { className: "c-fold-out__content", ref: ref, id: targetId }, children));
    }
    function renderTrigger(shortId) {
        return (React.createElement("div", { className: "c-fold-out__trigger" },
            React.createElement(Toggle, { className: "c-fold-out__trigger__button", iconClassName: "c-icon c-fold-out__trigger-icon", id: `${buttonId}-${shortId}`, targetId: targetId, 
                /**
                 * The {@link Toggle} object takes the invert state.
                 */
                hidden: !isOpen, labelHidden: labelHidden, labelUnhidden: labelUnhidden, targetRef: ref, 
                /**
                 * Pass in {@link Button.propTypes}.
                 */
                iconViaCss: true, link: true, small: true, simple: true, 
                /**
                 * Update the {@link FoldOut} state.
                 */
                onClick: handleToggle })));
    }
    return (React.createElement("div", { ...otherProps, "data-testid": testId, className: divClassNameList },
        renderHeader(),
        renderTrigger('header'),
        renderContent(),
        showFooterTrigger && renderTrigger('footer')));
}
